import { useEffect } from 'react';

const SITE = 'https://bluprise.com';
const DEFAULT_IMAGE = SITE + '/images/og-cover.png';

function ensureMeta(attrName, attrValue) {
  let el = document.head.querySelector('meta[' + attrName + '="' + attrValue + '"]');
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attrName, attrValue);
    document.head.appendChild(el);
  }
  return el;
}

// Per-route document metadata without a helmet dependency.
export default function useSeo({ title, description, path = '/', image = DEFAULT_IMAGE }) {
  useEffect(() => {
    const fullTitle = title ? title + ' — Bluprise' : 'Bluprise — Product Studio';
    document.title = fullTitle;
    if (description) {
      ensureMeta('name', 'description').setAttribute('content', description);
      ensureMeta('property', 'og:description').setAttribute('content', description);
      ensureMeta('name', 'twitter:description').setAttribute('content', description);
    }
    ensureMeta('property', 'og:title').setAttribute('content', fullTitle);
    ensureMeta('name', 'twitter:title').setAttribute('content', fullTitle);
    ensureMeta('property', 'og:url').setAttribute('content', SITE + path);
    ensureMeta('property', 'og:image').setAttribute('content', image);
    ensureMeta('name', 'twitter:image').setAttribute('content', image);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', SITE + path);
  }, [title, description, path, image]);
}
